export default "__VITE_ASSET__8NGE$MX4__"